import { render, staticRenderFns } from "./automatizacionReglas.vue?vue&type=template&id=03ae0247"
import script from "./automatizacionReglas.vue?vue&type=script&lang=js"
export * from "./automatizacionReglas.vue?vue&type=script&lang=js"
import style0 from "./automatizacionReglas.vue?vue&type=style&index=0&id=03ae0247&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports